import(/* webpackMode: "eager" */ "/app/src/app/(lobby)/layout.tsx");
